import { useTranslation } from 'react-i18next';
import { errorCode } from '@posilka/client/api/client';
import { Icon } from './Icon';
import { Skeleton } from './Skeleton';

export function EmptyState({
  icon,
  text,
  action,
}: {
  icon?: string;
  text: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-3 px-6 py-10 text-center">
      <span className="grid h-16 w-16 place-items-center rounded-2xl bg-surface-2 text-3xl text-muted">
        {icon ?? <Icon name="inbox" className="h-7 w-7" />}
      </span>
      <p className="text-muted">{text}</p>
      {action}
    </div>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useTranslation();
  const code = errorCode(error);
  const key = code ? `errors.${code}` : null;
  const message = key && t(key) !== key ? t(key) : t('common.error');
  // Server umuman javob bermadi — eng ko'p sabab: ilova eski (o'lik) manzil bilan ochiq qolgan.
  const unreachable = code === 'NETWORK_ERROR' || code === 'TIMEOUT';
  return (
    <div className="flex flex-col items-center gap-3 px-6 py-10 text-center">
      <span className="grid h-16 w-16 place-items-center rounded-2xl bg-danger/12 text-danger">
        <Icon name="alert" className="h-7 w-7" />
      </span>
      <p className="max-w-xs">{message}</p>
      {unreachable && <p className="max-w-xs text-sm text-muted">{t('common.reopenApp')}</p>}
      {onRetry && (
        <button type="button" className="btn-secondary" onClick={onRetry}>
          {t('common.retry')}
        </button>
      )}
    </div>
  );
}

export function ListSkeleton({ rows = 3 }: { rows?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} className="h-24" />
      ))}
    </div>
  );
}
